// frontend/src/features/campaign/components/create/WizardStepper.js
import React from 'react';

const STEPS = [
  {
    num: 1,
    title: '1. Brief & Goals',
    sub: 'Objective & Overview',
    generatingText: 'Synthesizing Brief',
  },
  {
    num: 2,
    title: '2. Target Cohort',
    sub: 'Audience & Leads',
    generatingText: 'Qualifying Cohort',
  },
  {
    num: 3,
    title: '3. Offer & Matrix',
    sub: 'Value Positioning',
    generatingText: 'Tailoring Messaging',
  },
  {
    num: 4,
    title: '4. Outreach Cadence',
    sub: 'Multi-Touch Sequence',
    generatingText: 'Crafting Sequence',
  },
  {
    num: 5,
    title: '5. Forecast & KPIs',
    sub: 'Pipeline Simulation',
    generatingText: 'Simulating KPIs',
  },
  { num: 6, title: '6. Governance', sub: 'Approval & Launch', generatingText: 'Scanning Policy' },
];

export default function WizardStepper({
  wizardStep,
  onStepClick,
  isEditMode = false,
  maxStepReached = 1,
  campaignStatus = null,
  isStepValid = () => false,
  isDisabled = false,
  stepGeneratingMap = {},
}) {
  return (
    <div className="cmp-wizard-top-stepper">
      {STEPS.map((s) => {
        const isActive = wizardStep === s.num;
        const isGenerating = Boolean(stepGeneratingMap[s.num]);
        const valid = Boolean(isStepValid(s.num));
        const isDone = valid && !isActive && !isGenerating;
        const isCardDisabled = isDisabled && !isActive;

        return (
          <div
            key={s.num}
            className={`cmp-tab-step-card ${isActive ? 'active' : ''} ${isDone ? 'done' : ''} ${isCardDisabled ? 'disabled' : ''} ${isGenerating ? 'is-thinking' : ''}`}
            onClick={() => {
              if (isDisabled) return;
              onStepClick(s.num);
            }}
            title={isGenerating ? `AI is currently generating content for ${s.title}` : undefined}
          >
            <div className="cmp-tab-step-badge">
              {isGenerating ? (
                <div className="cmp-tab-thinking-dribbble" title="AI is thinking and generating...">
                  <svg className="cmp-dribbble-svg" viewBox="0 0 28 28" width="15" height="15">
                    {/* Central morphing 4-point star */}
                    <path
                      className="cmp-dribbble-main-star"
                      d="M14 3.5C14 9.299 9.299 14 3.5 14C9.299 14 14 18.701 14 24.5C14 18.701 18.701 14 24.5 14C18.701 14 14 9.299 14 3.5Z"
                      fill="currentColor"
                    />
                    {/* Satellite accent sparkle 1 (top right) */}
                    <circle
                      className="cmp-dribbble-sat-1"
                      cx="21.5"
                      cy="6.5"
                      r="1.5"
                      fill="currentColor"
                    />
                    {/* Satellite accent sparkle 2 (bottom left) */}
                    <circle
                      className="cmp-dribbble-sat-2"
                      cx="6.5"
                      cy="21.5"
                      r="1.3"
                      fill="currentColor"
                    />
                    {/* Satellite accent sparkle 3 (top left) */}
                    <circle
                      className="cmp-dribbble-sat-3"
                      cx="6"
                      cy="6.5"
                      r="1.1"
                      fill="currentColor"
                    />
                    {/* Satellite accent sparkle 4 (bottom right) */}
                    <circle
                      className="cmp-dribbble-sat-4"
                      cx="22"
                      cy="21.5"
                      r="1.2"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              ) : isDone ? (
                <i className="fas fa-check" />
              ) : (
                s.num
              )}
            </div>
            <div className="cmp-tab-step-text">
              <span className="cmp-tab-step-title">{s.title}</span>
              <span className="cmp-tab-step-sub">
                {isGenerating ? (
                  <span className="cmp-tab-thinking-sub">
                    <span className="cmp-thinking-pulse-text">{s.generatingText}</span>
                    <span className="cmp-thinking-dots">
                      <span>.</span>
                      <span>.</span>
                      <span>.</span>
                    </span>
                  </span>
                ) : (
                  s.sub
                )}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
